import { useState, useMemo, forwardRef, useEffect } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import { getAllFavProjects, setProjectFav, updateProjectFav } from 'src/services/timeManagementService';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';

interface ProjectSelectProps {
  value: any,
  onChange: (e: any) => void,
  list: any,
  width?: string,
  disabled?: boolean
}

const ProjectSelect = forwardRef((props: ProjectSelectProps, _ref) => {
  const [searchText, setSearchText] = useState<string>('');
  const [updatedList, setUpdatedList] = useState(props.list || []);
  const employeeId = useSelector(
    (state: RootStateType) => state.appReducer.user.EmployeeId
  );

  const getFavorites = async () => {
    try {
      const res = await getAllFavProjects();
      const favorites = res?.data?.data || []; 
      console.log("favorites",favorites)

      const mergedList = props.list.map((project) => {
        // const isFavorite = favorites.some(
        //   (fav) => fav.projectId === project.value.projectId
        // );
        const favoriteMatch = favorites.find(
          (fav) => fav.projectId === project.value.projectId
        )
        console.log("isFavorite",)
        return {
          ...project,
          value: {
            ...project.value,
            // isFavorite: isFavorite,
            isFavorite: !!favoriteMatch, // true if found, false otherwise
            favId: favoriteMatch?.id || null, // Add favId from favorites
          }
        };
      });
      const sortedList = mergedList.sort((a, b) => {
        return b.value.isFavorite - a.value.isFavorite; 
      });

      setUpdatedList(sortedList);
    } catch (error) {
      console.error('Error fetching favorite projects:', error);
      const mergedList = props.list.map((project) => ({
        ...project,
        value: {
          ...project.value,
          isFavorite: false,
          favId:null 
        },
      }));
      setUpdatedList(mergedList);
    }
  };

  useEffect(() => {
    getFavorites();
  }, [props.list]);

  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const filteredProjects = useMemo(() => {
    return updatedList?.filter((option) => containsText(option?.label, searchText));
  }, [searchText,updatedList]);

  useEffect(() => {
    if (!props.value && updatedList?.length > 0) {
      props.onChange({ target: { value: updatedList[0].value } });
    }
  }, [updatedList]);


  const toggleFavorite = async (project) => {

    const { projectId, isFavorite,favId } = project.value;

    const requestBody = {
      id: favId, 
      employeeId: employeeId, 
      projectId,
      isFavorite: !isFavorite,
    };

    try {
      if (!isFavorite) {
        await setProjectFav(requestBody);
      } else {
        await updateProjectFav(requestBody);
      }

      setUpdatedList((prevList) =>
        prevList.map((item) =>
          item.value.projectId === projectId
            ? {
                ...item,
                value: {
                  ...item.value,
                  isFavorite: !isFavorite, 
                },
              }
            : item
        )
      );
      getFavorites();
    } catch (error) {
      console.error('Error toggling favorite:', error);
    }
  };



  return (
    <FormControl fullWidth disabled={props?.disabled ? props?.disabled : false}>
      {props?.value &&
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          Project Name
        </InputLabel>
      }
      <Select
        id="filter-project-taskAssign"
        placeholder="Project Name"
        style={{
          width: props?.width ? props?.width : '100%',
          fontSize: '12px',
          height: '1.75rem',
          marginTop: '8px'
        }}
        size="small"
        value={filteredProjects.find(option => option.value.projectId === props?.value?.projectId) ? filteredProjects.find(option => option.value.projectId === props?.value?.projectId).value : ''}
        onChange={(e) => props?.onChange(e)}
        onOpen={() => {setSearchText('')}}
      >
        <ListSubheader>
          <TextField
            id="search-project"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => {
              console.log(e.target.value)
              setSearchText(e.target.value)
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredProjects?.length > 0 &&
          filteredProjects.map((project, i) => {
            return (
              <MenuItem   style={{
                display: 'flex',
                justifyContent: 'space-between',
              }} key={project?.value?.projectId} value={project?.value}>{project?.label}   
              
              
              
              {project?.value?.isFavorite ? (
                <StarIcon
                  style={{ marginRight: 8, cursor: 'pointer', color: 'gold' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(project);
                  }}
                />
              ) : (
                <StarOutlineIcon
                  style={{ marginRight: 8, cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(project);
                  }}
                  />
                )}
 
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ProjectSelect;
